import React, { useEffect, useState } from 'react';

import { Application } from 'components/JobBoardDetails'
import { CandidateDetails } from "components/CandidateView";
import Api from 'api';

import {
    ItemContainer,
    Badge,
    TopSection,
    Image,
    Titles,
    CandidateName,
    CandidateExperience,
    StyledProImage,
    StyledEliteImage,
    StyledPersonOutlineIcon,
    StyledThumbUpAltOutlinedIcon,
    StyledThumbDownAltOutlinedIcon,
    NewCandidateBadge,
    ShortlistedCandidateBadge,
    DeclinedCandidateBadge,
    DetailViewInfo,
    DetailViewInfoItem,
    GraduationYear,
    StarIconInactive,
    StarIconActive,
} from "./ApplicationsList.styles";
import Rating from "@mui/material/Rating";
import {HYGIENIST_TYPES} from "../../utils/types";

interface ApplicationsListItemProps {
    application: Application
    onApplicationClick?: (application: Application) => void
    isNew?: boolean
    isShortlisted?: boolean
    candidateDetails?: CandidateDetails
    isHidden?: boolean
    isDeclined?: boolean
}

const ApplicationsListItem = ({application, onApplicationClick, isNew, isShortlisted, candidateDetails, isHidden, isDeclined}: ApplicationsListItemProps) => {
    const [hygienistStats, setHygienistStats] = useState<{ ratings_num: number }>({ ratings_num: 0 });
    useEffect(() => {
        const fetchHygienistStats = async () => {
            try {
                const stats = await Api.getHygienistStatsById({ hygienistId: application.hygienistId, applicationId: application.applicationId });
                setHygienistStats(stats);
            } catch (error) {
                console.error("Error fetching hygienist stats:", error);
            }
        };

        fetchHygienistStats();
    }, [application.hygienistId]);

    const isHygienistOrAssistant = application.type === HYGIENIST_TYPES.HYGIENIST
        || application.type === HYGIENIST_TYPES.ASSISTANT;

    return (
        <ItemContainer $isNew={!!isNew} className="no-fastclick" onClick={() => onApplicationClick && onApplicationClick(application)}>
            <TopSection>
                {application.photoUrl ? <Image src={application.photoUrl} alt={''} /> : null}
                <Titles $isDetailView={!!candidateDetails}>
                    {application.hygienistStatus === 1 || application.hygienistStatus === 2 ? (
                        <Badge>
                            {application.hygienistStatus === 1 && <StyledProImage />}
                            {application.hygienistStatus === 2 && <StyledEliteImage />}
                        </Badge>
                    ) : null}
                    <CandidateName $isDetailView={!!candidateDetails} $isHidden={isHidden || false}>{application.name}</CandidateName>
                    {!candidateDetails && (
                        <>
                            <CandidateExperience>
                                Graduated: {application.graduationYear} from: {application.school}
                            </CandidateExperience>
                            {isHygienistOrAssistant && <DetailViewInfoItem>
                                <Rating
                                    name="candidateRating"
                                    value={application.rating}
                                    readOnly
                                    precision={0.01}
                                    emptyIcon={<StarIconInactive />}
                                    icon={<StarIconActive />}
                                />
                                <div>{hygienistStats.ratings_num} {hygienistStats.ratings_num === 1 ? 'Rating' : 'Ratings'}</div>
                            </DetailViewInfoItem>}
                        </>
                    )}
                    {candidateDetails ? (
                        <DetailViewInfo>
                            {isHygienistOrAssistant && <DetailViewInfoItem>
                                <Rating
                                    name="candidateRating"
                                    value={application.rating}
                                    readOnly
                                    precision={0.01}
                                    emptyIcon={<StarIconInactive />}
                                    icon={<StarIconActive />}
                                />
                                <div>{candidateDetails.reviewsCount} {candidateDetails.reviewsCount === 1 ? 'Rating' : 'Ratings'}</div>
                            </DetailViewInfoItem>}
                            <DetailViewInfoItem $isGraduationYear={true}>
                                <GraduationYear>{application.graduationYear}</GraduationYear>
                                <div>Graduation year</div>
                            </DetailViewInfoItem>
                        </DetailViewInfo>
                    ) : null}
                </Titles>
                {isNew ? (
                        <NewCandidateBadge $isDetailView={!!candidateDetails}>
                            <StyledPersonOutlineIcon />
                            <span>New</span>
                        </NewCandidateBadge>
                    ) : null}
                    {isShortlisted ? (
                        <ShortlistedCandidateBadge $isDetailView={!!candidateDetails}>
                            <StyledThumbUpAltOutlinedIcon />
                            <span>Shortlisted</span>
                        </ShortlistedCandidateBadge>
                    ) : null}
                    {isDeclined ? (
                        <DeclinedCandidateBadge $isDetailView={!!candidateDetails}>
                            <StyledThumbDownAltOutlinedIcon />
                            <span>Declined</span>
                        </DeclinedCandidateBadge>
                    ) : null}
            </TopSection>
        </ItemContainer>
    )
}

export default ApplicationsListItem;
